<template>
  <hic-dialog append-to-body title="网页编辑" :visible="visible" @close="cancel" top="6vh" width="55rem" @open="open"
    :close-on-click-modal="false">
    <div v-loading="meta.loading">
      <el-form :model="value" :rules="comRules" ref="submitForm" label-width="7rem" label-position="right"
        style="padding-right: 3rem">
        <el-row>
          <el-col :span="12">
            <el-form-item label="编码" prop="code">
              <el-tag v-if="value.id" style="width: 100%" plain>
                <b>{{ value.code }}</b>
              </el-tag>
              <el-input v-else size="small" type="text" placeholder="请输入编码" v-model.trim="value.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="value.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色限制" prop="" title="选择当前页面允许浏览的角色，保持空则允许所有人浏览">
              <el-select size="small" v-model="roles" placeholder="选择当前页面允许浏览的角色，保持空则允许所有人浏览" multiple collapse-tags value-key="id"
                style="width: 100%" clearable>
                <el-option v-for="item in option.roles" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="页面架构" prop="">
              <hic-dict-selector dict-type="PageLayout" is-enum placeholder="页面架构" v-model="value.layout" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="显示面包屑" prop="">
              <el-checkbox v-model="value.showBreadcrumb" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="参数" prop="">
              <el-input v-model="value.params" placeholder="请输入参数" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="页面说明" prop="">
              <el-input v-model="value.memo" placeholder="请输入页面说明" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider>模块列表</el-divider>
      <el-table ref="expandTable" :data="modules" style="width: 100%">
        <el-table-column align="center" label="操作" width="120" key="iousCmd">
          <template #header="scope">
            <el-popover placement="top-start" width="650" trigger="click">
              <el-row type="flex" justify="space-between" align="center">
                <b>模块选择:</b>
                <el-input v-model="modelKeyword" size="mini" class="condition-wide" prefix-icon="el-icon-search" clearable />
              </el-row>
              <el-table height="350" :data="filteredOptions" size="mini" empty-text="没有可选的模板">
                <el-table-column width="55">
                  <template #default="{ row }">
                    <el-button type="primary" size="mini" circle icon="el-icon-plus" plain @click="add(row)" />
                  </template>
                </el-table-column>
                <el-table-column align="left" label="名称" prop="name" sortable>
                  <template #default="{ row }">
                    <b>{{ row.name }}</b>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="编码" prop="code" width="100" sortable />
                <el-table-column align="left" label="浏览权限" prop="roles">
                  <template #default="{ row }">
                    <span>{{ row.roles | namesFilter }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="数据类型" prop="name" width="90">
                  <template #default="{ row }">
                    <el-tag v-if="row.resultType == '分页列表'" type="danger" size="small" hit>{{ row.resultType }}</el-tag>
                    <el-tag v-if="row.resultType == '对象'" type="success" size="small" hit>{{ row.resultType }}</el-tag>
                    <el-tag v-if="row.resultType == '列表'" type="warning" size="small" hit>{{ row.resultType }}</el-tag>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <el-empty description="没有可选的模板" />
                </template>
              </el-table>
              <el-button slot="reference" type="primary" class="el-icon-plus" size="mini" plain round>添加</el-button>
            </el-popover>
          </template>
          <template slot-scope="props">
            <el-button type="primary" title="编辑" size="mini" icon="el-icon-edit" circle plain @click="edit(props.row)"></el-button>
            <el-button type="danger" title="删除" size="mini" icon="el-icon-delete" circle plain
              @click="del(props.$index)"></el-button>
          </template>
        </el-table-column>
        <el-table-column align="left" label="编码" prop="code" width="120" sortable>
          <template #default="{ row }">
            <div v-if="!row.isEdit">{{ row.code }}</div>
            <el-input v-else size="small" type="text" placeholder="请输入字段编码" v-model.trim="row.code" />
          </template>
        </el-table-column>
        <el-table-column align="left" label="名称" prop="name" sortable>
          <template #default="{ row }">
            <div v-if="!row.isEdit">{{ row.name }}</div>
            <el-input v-else size="small" type="text" placeholder="请输入名称" v-model.trim="row.name" />
          </template>
        </el-table-column>
        <el-table-column align="left" label="浏览权限" prop="roles">
          <template #default="{ row }">
            <span>{{ row.roles | namesFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="数据类型" prop="name" width="120">
          <template #default="{ row }">
            <el-tag v-if="row.resultType == '分页列表'" type="danger" size="small" hit>{{ row.resultType }}</el-tag>
            <el-tag v-if="row.resultType == '对象'" type="success" size="small" hit>{{ row.resultType }}</el-tag>
            <el-tag v-if="row.resultType == '列表'" type="warning" size="small" hit>{{ row.resultType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="name" width="80" align="center" sortable>
          <template #default="{ row }">
            <el-input v-model="row.order" size="small" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="meta.loading">确 定</el-button>
    </div>
    <EditorModule v-model="editing" :visible.sync="meta.showEditor" @close="updated"></EditorModule>
  </hic-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    visible: Boolean,
    value: Object,
  },
  components: {
    EditorModule: () => import("../module/edit"),
  },
  data() {
    return {
      meta: {
        loading: false,
        showEditor: false,
      },
      comRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
        uri: [{ required: true, message: "请输入连接字符串", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      option: {
        modules: [],
        roles: [],
      },
      roles: [],
      modules: [],
      editing: {},
      isReload: true,
      modelKeyword: null
    };
  },
  computed: {
    ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    options() {
      return this.option.modules.filter((m) => this.modules.findIndex((o) => o.id == m.id) < 0);
    },
    filteredOptions() {
      if (!this.modelKeyword) {
        return this.options
      }
      return this.options.filter(m => m.name.includes(this.modelKeyword) || m.code.includes(this.modelKeyword))
    }
  },
  // watch: {
  //   modules(newval) {
  //     this.$set(this.value, "roles", JSON.stringify(this.roles));
  //     this.$set(this.value, "modules", JSON.stringify(this.modules));
  //   },
  // },
  filters: {
    namesFilter(val) {
      try {
        if (!val) return "";
        val = JSON.parse(val);
        let list = val.map((el) => {
          return el.name;
        });
        return list.join(",");
      } catch (error) {
        return val;
      }
    },
  },
  created() {
    api.Role.query({})
      .then((res) => {
        this.option.roles = res.items.map((i) => ({ id: i.id, code: i.code, name: i.name }));
      })
      .catch((err) => {
        this.$message.error(err);
        this.meta.loading = false;
      })
      .finally(() => {
        this.meta.loading = false;
      });
    api.Module.query({})
      .then((res) => {
        this.option.modules = res.items;
      })
      .catch((err) => {
        this.$message.error(err);
        this.meta.loading = false;
      })
      .finally(() => {
        this.meta.loading = false;
      });
  },
  methods: {
    open() {
      this.roles = [];
      this.modules = [];
      if (this.value.roles) {
        this.roles = JSON.parse(this.value.roles);
      }
      if (this.value.modules) {
        this.modules = JSON.parse(this.value.modules);
      }

      // if (this.value.roles) this.$set(this, "roles", JSON.parse(this.value.roles));
      // if (this.value.modules) {
      //   this.$set(this, "modules", JSON.parse(this.value.modules));
      //   this.modules.forEach((el) => {
      //     this.getNewModules(el);
      //   });
      // }
      if (this.$refs.submitForm) {
        this.$refs.submitForm.resetFields();
      }

      // this.getUserRoles();
      // this.getModules();
    },
    // getNewModules(item) {
    //   try {
    //     api.Module.get(item.id).then((res) => {
    //       let _index = this.modules.findIndex((el) => el.id == item.id);
    //       this.$set(this.modules, _index, res);
    //     });
    //   } catch (error) {
    //     console.log("---error-->", error);
    //   }
    // },
    // getUserRoles() {
    //   api.Role.query({})
    //     .then((res) => {
    //       this.option.roles = res.items;
    //     })
    //     .catch((err) => {
    //       this.$message.error(err);
    //       this.meta.loading = false;
    //     })
    //     .finally(() => {
    //       this.meta.loading = false;
    //     });
    // },
    // getModules() {
    //   api.Module.query({})
    //     .then((res) => {
    //       this.option.modules = res.items;
    //     })
    //     .catch((err) => {
    //       this.$message.error(err);
    //       this.meta.loading = false;
    //     })
    //     .finally(() => {
    //       this.meta.loading = false;
    //     });
    // },
    updated(info) {
      this.isReload = false;
      let i = this.modules.findIndex((ele) => ele.id === info.id);
      let { id, code, name, roles, resultType } = info;
      let order = this.modules[i].order;
      this.$set(this.modules, i, { id, code, name, roles, resultType, order });
    },
    cancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    save() {
      this.$refs.submitForm.validate().then((valid) => {
        if (valid) {
          this.value.roles = JSON.stringify(this.roles);
          this.value.modules = JSON.stringify(this.modules.sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999)));
          this.meta.loading = true;
          api.Page.save(this.value)
            .then((res) => {
              this.$message.success("保存成功!");
              this.$store.dispatch("loaders", "WebPage");
              this.$emit("close");
              this.cancel();
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.meta.loading = false;
            });
        }
      });
    },
    edit(row) {
      api.Module.get(row.id).then((res) => {
        this.editing = res;
        this.meta.showEditor = true;
      });
    },
    del(_index) {
      this.modules.splice(_index, 1);
    },
    add(row) {
      let { id, code, name, roles, resultType } = row;
      let order = this.modules.length + 1;
      this.modules.push({ id, code, name, roles, resultType, order });
    },
  },
};
</script>
